<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              Category Details
            </h4>
            <v-simple-table v-if="$route.params.id != 0">
              <tbody>
                <tr>
                  <td>
                    Name
                  </td>
                  <td>
                    {{ categoryModel.name ? categoryModel.name : '' }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Parent
                  </td>
                  <td>
                    {{ categoryModel.parent ? categoryModel.parent : '' }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Priority
                  </td>
                  <td>
                    {{ categoryModel.priority ? categoryModel.priority : 0 }}
                  </td>
                </tr>
                <tr>
                  <td>
                    CreatedBy
                  </td>
                  <td>
                    {{ categoryModel.createdBy ? categoryModel.createdBy : '' }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-btn v-if="$route.params.id == 0" color="primary" :to="`${$route.path}/edit`" class="mr-2"
              >Create a New Category</v-btn
            >
            <v-btn v-else color="primary" :to="`${$route.path}/edit`" class="mr-2">Edit</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Category } from '@/models/Category';
import { gql } from 'apollo-boost';
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      categoryModel: new Category(),
      me: '',
      search: null,
      crumbs: [
        {
          text: 'Categories',
          disabled: false,
          href: '/admin/categories',
        },
        {
          text: 'Category Details',
          disabled: true,
          href: `/admin/category/${this.$route.params.id}`,
        },
      ],
    };
  },
  created() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    category: {
      query: gql`
        query Category($id: ID!) {
          category(id: $id) {
            id
            name
            parent
            priority
            createdBy
          }
        }
      `,
      fetchPolicy: 'network-only',
      skip() {
        return !this.$route.params.id || this.$route.params.id == 0;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response, key) {
        console.log('got data');
        this.isLoading = false;
        this.categoryModel.id = this.category.id;
        this.categoryModel.name = this.category.name;
        this.categoryModel.parent = this.category.parent;
        this.categoryModel.priority = this.category.priority;
        this.categoryModel.createdBy = this.category.createdBy;
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
